import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import * as moment from 'moment';
import { IAlbum, Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Branch from 'src/app/model/branch/branch';
import { NotExecutedHistoryItem } from 'src/app/model/history-item/not-executed-history-item';
import { NotExecutedHistoryItemAsset } from 'src/app/model/history-item/not-executed-history-item-asset';
import Employee from 'src/app/model/product/employee';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';
import { User } from 'src/app/model/user';
import { ImmoIPPlacerImmoTaskChangesFunctions } from 'src/app/pages/immo-ip/placer/tour-item-detail/immo-task/helper/change-storage-handler/immo-ip-placer-immo-task-change-functions';
import { ImmoIPPlacerTourItemDetailNotExecutedModalHelper } from 'src/app/pages/immo-ip/placer/tour-item-detail/not-executed-modal/immo-ip-placer-tour-item-detail-not-executed-modal-helper';
import { IPInstallerListControllerRequestService } from 'src/app/pages/immo-ip/tour/tour-page/service/ip-installer-list-controller-request.service';
import { EditNotExecutedHistoryItemControllerRequestService } from 'src/app/services/api/history-item/edit-not-executed-history-item-controller-request.service';
import { HandleNotExecutedSubProjectControllerRequestService } from 'src/app/services/api/history-item/handle-not-executed-sub-project-controller-request.service';
import { AuthService } from 'src/app/services/auth.service';
import { BranchChoicesService } from 'src/app/services/branch/branch-choices.service';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SnackService } from 'src/app/services/snack.service';
import { TabsService } from 'src/app/services/tabs.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import {
  DisplayNotExecutedHistoryItemHelper,
  HowToHandleOption,
} from './display-not-executed-history-item-helper';

@Component({
  selector: 'display-not-executed-history-item',
  templateUrl: './display-not-executed-history-item.component.html',
  styleUrls: ['./display-not-executed-history-item.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DateHelper.DEFAULT_MOMENT_FORMATS,
    },
  ],
})
export class DisplayNotExecutedHistoryItemComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  notExecutedHistoryItem: NotExecutedHistoryItem;

  @Input()
  project: Project;

  @Input()
  subProject: SubProject;

  @Input()
  displayOnly: boolean = false;

  @Input()
  title: string;

  @Input()
  editable: boolean = false;

  @Input()
  useMatCard: boolean = false;

  @Input()
  divergentPricesOnly: boolean = false;

  firstAsset: NotExecutedHistoryItemAsset;

  appointmentWasRequested: boolean;

  readonly HowToHandleOption = HowToHandleOption;
  selectedHandleOption: HowToHandleOption;

  contactName: string;
  contactEmail: string;

  delayedReason: string;

  employeeOptions: Employee[];
  newTourEmployee: Employee;
  newTourDate: moment.Moment;
  today = new Date();

  delayHandlerOptions: Employee[];
  delayHandler: Employee;
  handleDelayByDate: moment.Moment;

  appointmentEmployeeOptions: Employee[];
  appointmentFollowUpEmployee: Employee;
  appointmentFollowUpDate: moment.Moment;

  branchOptions: Branch[];
  noBranchOption: Branch;

  submitting: boolean = false;
  savingInfo: boolean = false;
  saved: boolean = false;

  orginalNotExecuted: NotExecutedHistoryItem = null;
  user: User = null;

  stockedAtBranch: boolean | null = null;
  stockedAtBranchSubtitle: string;

  onlineInfoCtrl = new FormControl();

  constructor(
    private authService: AuthService,
    private handleNotExecutedSubProjectControllerRequestService: HandleNotExecutedSubProjectControllerRequestService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private ipInstallerListControllerRequestService: IPInstallerListControllerRequestService,
    private branchChoicesService: BranchChoicesService,
    private employeeChoicesService: EmployeeChoicesService,
    private editNotExecutedHistoryItemControllerRequestService: EditNotExecutedHistoryItemControllerRequestService,
    private snackService: SnackService,
    private tabsService: TabsService,
    private _lightbox: Lightbox
  ) {
    super();

    this.noBranchOption = new Branch();
    this.noBranchOption.name = 'Geen';
  }

  ngOnInit(): void {
    if(this.editable) {
      this.onlineInfoCtrl.setValidators(Validators.required);
    }
    this.onlineInfoCtrl.setValue(this.notExecutedHistoryItem.onlineInfo);
    this.onlineInfoCtrl.updateValueAndValidity();

    if (CollectionHelper.isPopulated(this.notExecutedHistoryItem.assets)) {
      this.firstAsset = this.notExecutedHistoryItem.assets[0];
    }

    if (!this.displayOnly) {
      this.initHowToHandle();
    }

    this.orginalNotExecuted = { ...this.notExecutedHistoryItem };

    this.stockedAtBranchSubtitle =
      ImmoIPPlacerTourItemDetailNotExecutedModalHelper.getStockedAtBranchSubtitle(
        this.subProject.type
      );
    this.stockedAtBranch =
      this.notExecutedHistoryItem.stockAtBranch != null ||
      (this.notExecutedHistoryItem.stockAtBranch != null &&
        this.notExecutedHistoryItem.stockAtBranch.id == null);

    this.initializeSubscriptions();
  }

  private initHowToHandle() {
    this.appointmentWasRequested =
      this.subProject.projectPlacement != null &&
      (this.subProject.projectPlacement.appointment ||
        this.subProject.projectPlacement.collectKey);
    this.calculateFirstProjectContact();
    this.ipInstallerListControllerRequestService
      .IPInstallerList()
      .then((employees: Employee[]) => (this.employeeOptions = employees));
  }

  private initializeSubscriptions(): void {
    if (!this.displayOnly) {
      this.addSubscription(
        this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
        () => this.calculateFirstProjectContact()
      );
    }
    if (this.editable) {
      this.addSubscription(
        this.branchChoicesService.getBranchChoicesSubscribable(),
        (branches: Branch[]) => (this.branchOptions = branches)
      );
      this.addSubscription(
        this.employeeChoicesService.getImmoAdminChoicesSubscribable(),
        (immoAdmins: Employee[]) => {
          this.handleDelayHandlerOptionsLoaded(immoAdmins);
          this.handleAppointmentEmployeeOptionsLoaded(immoAdmins);
        }
      );
    }
    this.addSubscription(
      this.authService.getAuthenticatedUserSubscribable(),
      (user) => {
        this.user = user;
      }
    );
  }

  private calculateFirstProjectContact(): void {
    const firstProjectContact = CollectionHelper.isPopulated(
      this.project.projectContacts
    )
      ? this.project.projectContacts[0]
      : null;
    if (firstProjectContact == null) {
      this.contactName = null;
      this.contactEmail = null;
    } else {
      this.contactName = firstProjectContact.contact.firstName;
      this.contactEmail = CollectionHelper.isPopulated(
        firstProjectContact.contact.emails
      )
        ? firstProjectContact.contact.emails[0].email
        : null;
    }
  }

  private handleAppointmentEmployeeOptionsLoaded(options: Employee[]): void {
    this.appointmentEmployeeOptions = options;
    if (this.subProject.projectPlacement.appointmentFollowUpEmployee == null) {
      const authenticatedUser = this.authService.getAuthenticatedUser();
      this.appointmentFollowUpEmployee =
        authenticatedUser == null
          ? null
          : this.appointmentEmployeeOptions.find(
              (o) => o.user != null && o.user.id === authenticatedUser.id
            );
    } else {
      this.appointmentFollowUpEmployee =
        this.subProject.projectPlacement.appointmentFollowUpEmployee;
    }
  }

  private handleDelayHandlerOptionsLoaded(options: Employee[]): void {
    this.delayHandlerOptions = options;
    if (this.subProject.delayHandler == null) {
      const authenticatedUser = this.authService.getAuthenticatedUser();
      this.delayHandler =
        authenticatedUser == null
          ? null
          : this.delayHandlerOptions.find(
              (o) => o.user != null && o.user.id === authenticatedUser.id
            );
    } else {
      this.delayHandler = this.subProject.delayHandler;
    }
  }

  selectedHandleOptionChanged(): void {
    if (this.selectedHandleOption === HowToHandleOption.DELAY) {
      this.employeeChoicesService.updateImmoAdminChoices();
      this.delayedReason = this.notExecutedHistoryItem.content;
      this.handleDelayByDate =
        this.subProject.handleDelayByDate == null
          ? DateHelper.getMoment()
          : DateHelper.parseMoment(this.subProject.handleDelayByDate);
    } else if (
      this.selectedHandleOption === HowToHandleOption.RESCHEDULE_APPOINTMENT
    ) {
      this.employeeChoicesService.updateImmoAdminChoices();
      this.appointmentFollowUpDate =
        this.subProject.projectPlacement.appointmentFollowUpDate == null
          ? DateHelper.getMoment()
          : DateHelper.parseMoment(
              this.subProject.projectPlacement.appointmentFollowUpDate
            );
    } else {
      this.delayedReason = null;
      this.delayHandler = null;
      this.handleDelayByDate = null;
    }

    if (
      this.selectedHandleOption !== HowToHandleOption.REMOVE_FROM_CURRENT_TOUR
    ) {
      this.newTourEmployee = null;
      this.newTourDate = null;
    }
  }

  resetNewTourSelection(): void {
    this.newTourEmployee = null;
    this.newTourDate = null;
  }

  resetAppointmentFollowUpSelection(): void {
    this.appointmentFollowUpEmployee = null;
    this.appointmentFollowUpDate = null;
  }

  openLightbox(): void {
    const album: IAlbum[] = this.createLightboxAlbum();
    if (CollectionHelper.isPopulated(album)) {
      this._lightbox.open(album);
    }
  }

  private createLightboxAlbum(): IAlbum[] {
    if (!CollectionHelper.isPopulated(this.notExecutedHistoryItem.assets)) {
      return null;
    }

    const toReturn: IAlbum[] = this.notExecutedHistoryItem.assets.map((a) => {
      if (a.asset == null) {
        return null;
      }
      return {
        src: `/api/assets/${a.asset.uuid}`,
        thumb: `/api/assets/${a.asset.uuid}`,
      };
    });

    CollectionHelper.filterInPlace(toReturn, (e) => e != null);

    return toReturn;
  }

  submitHandleNotExecuted(): void {
    if(!this.onlineInfoCtrl.valid){
      this.snackService.showError('Gelieve het veld "Online feedback" in te vullen');
      this.onlineInfoCtrl.markAsTouched();
      return;
    }
    const verificationError =
      DisplayNotExecutedHistoryItemHelper.verifyHowToHandle(
        this.selectedHandleOption,
        this.newTourEmployee,
        this.newTourDate
      );
    if (verificationError != null) {
      this.snackService.showError(verificationError);
      return;
    }

    if (this.selectedHandleOption === HowToHandleOption.INVOICE_PARTIALLY) {
      const priceLineError = this.verifyPriceLines();
      if (priceLineError != null) {
        this.snackService.showError(priceLineError);
        return;
      }
    }

    this.submitting = true;
    this.handleNotExecutedSubProjectControllerRequestService
      .handleNotExecutedSubProject(
        this.subProject.id,
        this.selectedHandleOption,
        this.delayedReason,
        this.delayHandler == null ? null : this.delayHandler.id,
        this.handleDelayByDate,
        this.newTourEmployee == null ? null : this.newTourEmployee.id,
        this.newTourDate,
        this.appointmentFollowUpEmployee == null
          ? null
          : this.appointmentFollowUpEmployee.id,
        this.appointmentFollowUpDate
      )
      .then(() => {
        this.tabsService.closeTab(this.tabsService.getActiveTab(), null, false);
      })
      .finally(() => (this.submitting = false));
  }

  saveNotExecutedInfo(): void {
    if(!this.onlineInfoCtrl.valid){
      this.snackService.showError('Gelieve het veld "Online feedback" in te vullen');
      this.onlineInfoCtrl.markAsTouched();
      return;
    }
    this.savingInfo = true;
    this.editNotExecutedHistoryItemControllerRequestService
      .editNotExecutedHistoryItem(this.notExecutedHistoryItem)
      .then(() =>
        this.snackService.showSuccess(
          'Info niet uitgevoerd succesvol aangepast'
        )
      )
      .finally(() => {
        this.savingInfo = false;
        this.saved = true;
        if (
          this.orginalNotExecuted.callClient !=
          this.notExecutedHistoryItem.callClient
        ) {
          this.notExecutedHistoryItem.clientCommunicationRegistration =
            ImmoIPPlacerImmoTaskChangesFunctions.initializeExecutedRegistration(
              new Date(),
              this.user
            );
        }
        if (
          this.orginalNotExecuted.callInpress !=
          this.notExecutedHistoryItem.callInpress
        ) {
          this.notExecutedHistoryItem.inpressCommunicationRegistration =
            ImmoIPPlacerImmoTaskChangesFunctions.initializeExecutedRegistration(
              new Date(),
              this.user
            );
        }
      });
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  compareBranches(o1: Branch, o2: Branch): boolean {
    return GeneralHelper.compareEntitiesSupportingNull(o1, o2);
  }

  verifyPriceLines(): string {
    let total = 0;
    this.subProject.projectInvoices.forEach((pi) => {
      const invoiceTotal = pi.priceLines
        .map((pl) => parseFloat(pl.price))
        .reduce((totalPrice, currentPrice) => totalPrice + currentPrice);
      total += invoiceTotal;
    });
    if (total === 0) {
      return 'Je probeert een opdracht zonder prijs naar facturatie te sturen. Gelieve een afwijkende prijs in te geven.';
    }
    if (!this.divergentPricesOnly) {
      return '"Enkel onderstaande prijs in rekening brengen" moet aangevinkt zijn alvorens een opdracht naar facturatie gestuurd kan worden.';
    }
  }

  setCallClient(value: boolean) {
    this.notExecutedHistoryItem.callClient = value;
    if (!value) {
      this.notExecutedHistoryItem.clientCommunicationSummary = null;
    }
  }

  setCallInpress(value: boolean) {
    this.notExecutedHistoryItem.callInpress = value;
    if (!value) {
      this.notExecutedHistoryItem.inpressCommunicationSummary = null;
    }
  }

  setStockedAtBranch(stockedAtBranch: boolean): void {
    this.stockedAtBranch = stockedAtBranch;
    if (!stockedAtBranch) {
      this.notExecutedHistoryItem.stockAtBranch = this.noBranchOption;
    }
  }
}
